import type { PanelManager } from '../core/PanelManager';

/**
 * Standalone ⚙ gear button pinned to the top-left of the screen.
 *
 * Replaces the gear entry in the old right-side ActionsBar. Now lives
 * on its own in the opposite corner so the SettingsModal (which
 * pauses the game) is reachable from a deliberate, isolated affordance
 * rather than buried among other action icons that move state around.
 *
 * Clicking opens the centered Settings modal via the panel manager.
 */
export class SettingsButton {
  private root: HTMLButtonElement;

  constructor(parent: HTMLElement, private panels: PanelManager) {
    this.root = document.createElement('button');
    this.root.className = 'ui-settings-btn';
    this.root.title = 'Settings (sound, graphics, controls, save)';
    this.root.innerHTML = `<span class="ui-settings-btn__icon glyph">⚙</span>`;
    this.root.addEventListener('click', () => this.panels.toggle('settings'));
    parent.appendChild(this.root);
  }
}
